// GRAM currency mark — ton.org-standard gem + sparkle hole. Brand colour is
// --gram (#30A1F5), deliberately SEPARATE from the UI accent (#0372F6) —
// never merge the two. Canonical SVG cloned from Paper UEK-0; do not redraw.
// Default sparkle is a knockout (surface shows through), not a white fill.

interface Props {
  size?: number
  /** Muted single-tone variant for places colour can't read. */
  mono?: boolean
  /** Solid-ink gem with the sparkle KNOCKED OUT (hollow) so the surface
      behind shows through — for use on a coloured fill (the buy/sell CTA).
      Inherits currentColor. */
  knockout?: boolean
  /** Аутлайн-вариант: контур гема + звезда заливкой (звезда ВИДНА — фидбек:
      mono сливал её с гемом в «просто алмаз»). Inherits currentColor. */
  outline?: boolean
  /** Круглый логотип: белый алмаз со сквозной звездой на диске #30A1F5.
      Макет: «на круглом логотипе белый по #30A1F5». Operations-бейдж и Send. */
  logo?: boolean
  className?: string
}

const GEM =
  'M11.608 1.25a2.5 2.5 0 0 1 2.12 1.175l1.668 2.669a2.5 2.5 0 0 1-.119 2.825l-.13.16-5.282 5.95a2.5 2.5 0 0 1-3.734.004L.815 8.081a2.5 2.5 0 0 1-.256-2.99l1.666-2.666a2.5 2.5 0 0 1 2.12-1.175z'
const SPARK =
  'M9.286 3.932a.296.296 0 0 1 .555 0l.49 1.326c.022.06.069.106.128.128l1.326.49a.296.296 0 0 1 0 .555l-1.326.49a.22.22 0 0 0-.128.128l-.49 1.327a.296.296 0 0 1-.555 0l-.49-1.327a.22.22 0 0 0-.128-.128l-1.326-.49a.296.296 0 0 1 0-.554l1.326-.49a.22.22 0 0 0 .128-.129z'
const GEM_KNOCKOUT = `${GEM} ${SPARK}`

export function GramMark({
  size = 16,
  mono = false,
  knockout = false,
  outline = false,
  logo = false,
  className,
}: Props) {
  if (logo) {
    // замер 5i: диск 16, гем scale(.7) со смещением (2.42, 2.36)
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <circle cx="8" cy="8" r="8" fill="#30a1f5" />
        <g transform="translate(2.42 2.36) scale(0.7)">
          <path fillRule="evenodd" clipRule="evenodd" d={GEM_KNOCKOUT} fill="#ffffff" />
        </g>
      </svg>
    )
  }
  if (outline) {
    // viewBox расширен на полстроука: обводка центрована на контуре и иначе
    // срезается по правому/нижнему краю (фидбек: «часть гема справа не видна»)
    return (
      <svg
        width={size}
        height={size}
        viewBox="-0.8 -0.8 17.6 17.6"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <path d={GEM} fill="none" stroke="currentColor" strokeWidth="1.2" />
        <path d={SPARK} fill="currentColor" />
      </svg>
    )
  }
  if (knockout) {
    // gem + sparkle as one even-odd path → sparkle becomes a transparent hole.
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <path fillRule="evenodd" clipRule="evenodd" d={GEM_KNOCKOUT} fill="currentColor" />
      </svg>
    )
  }
  const gem = mono ? '#9aa0a8' : 'var(--gram)'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path fillRule="evenodd" clipRule="evenodd" d={GEM_KNOCKOUT} fill={gem} />
    </svg>
  )
}
